import { render, staticRenderFns } from "./testRadio.vue?vue&type=template&id=bbe9e668&scoped=true"
import script from "./testRadio.vue?vue&type=script&lang=js"
export * from "./testRadio.vue?vue&type=script&lang=js"
import style0 from "./testRadio.vue?vue&type=style&index=0&id=bbe9e668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe9e668",
  null
  
)

export default component.exports